var render, staticRenderFns
import script from "./BarChart.vue?vue&type=script&lang=ts&"
export * from "./BarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bb91d6",
  null
  
)

export default component.exports